import { IDLE } from "../../global/statusLabels";
import { IS_AUTHENTICATED_SUCCESS, RESET_AUTH_STATE, USER_INFO_SUCCESS } from "./actionsType";


export const initialState = {

    isAuthenticated: false,
    authType: undefined,//SPID CFTNS
    userInfo: { value: undefined, status: IDLE },

}

export const authReducer = (state = initialState, action) => {

    switch (action.type) {

        case IS_AUTHENTICATED_SUCCESS:
            return {
                ...state,
                isAuthenticated: action.payload.isAuthenticated,
                authType: action.payload.authType
            }

        case USER_INFO_SUCCESS:
            return {
                ...state,
                userInfo: action.payload
            }

        case RESET_AUTH_STATE:
            return initialState

        case 'persist/REHYDRATE':
            return state;

        default:
            return state;
    }
}